/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BinaryFileType } from '../../models/binary-file-type';
import { KeyType } from '../../models/key-type';

export interface GetConsigneeDiscrepancyReceiptAttachment$Png$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;

/**
 * The delivery note key
 */
  deliveryNoteKey: KeyType;

/**
 * The attachment key
 */
  attachmentKey: KeyType;
}

export function getConsigneeDiscrepancyReceiptAttachment$Png(http: HttpClient, rootUrl: string, params: GetConsigneeDiscrepancyReceiptAttachment$Png$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
  const rb = new RequestBuilder(rootUrl, getConsigneeDiscrepancyReceiptAttachment$Png.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
    rb.path('attachmentKey', params.attachmentKey, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'image/png', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BinaryFileType>;
    })
  );
}

getConsigneeDiscrepancyReceiptAttachment$Png.PATH = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}/receipts/{attachmentKey}';
